import { api } from '@/api'
import { TRACKING_TYPES, type TrackingType } from './trackingConst'

class TrackingService {
  private getUtmChannel(): string | undefined {
    const params = new URLSearchParams(window.location.search)
    const utm = params.get('utm')?.trim()
    if (!utm) return undefined
    return utm
  }

  private send(type: TrackingType, channel?: string) {
    const payload = channel ? { type, channel } : { type }

    api.tracking
      .trackEvent(payload)
      .send(true)
      .catch(() => {
        // 埋点失败不影响业务逻辑
      })
  }

  /**
   * 页面跳出等卸载场景埋点
   * 页面卸载时普通 XHR 会被中断，使用 sendBeacon 保证送达
   */
  trackByBeacon(type: TrackingType) {
    const payload = JSON.stringify({
      type,
    })
    navigator.sendBeacon(
      `${window.location.origin}/ad_api/tracking/event`,
      new Blob([payload], { type: 'application/json' }),
    )
  }

  /** 首页访问 */
  trackHomePageView() {
    this.send(TRACKING_TYPES.HOME_PAGE_VISIT, this.getUtmChannel())
  }

  /** 注册页访问 */
  trackRegisterPageView() {
    this.send(TRACKING_TYPES.REGISTER_PAGE_VISIT)
  }

  /** 后台访问 */
  trackDashboardPageView() {
    this.send(TRACKING_TYPES.BACKEND_PAGE_VISIT)
  }

  /**
   * 注册完成（信息绑定成功）
   * 后端通过 register_success / register_page_visit 计算注册页跳出率
   */
  trackRegisterComplete() {
    this.send(TRACKING_TYPES.REGISTER_SUCCESS)
  }

  /**
   * 首页跳出
   */
  trackHomePageBounce() {
    this.trackByBeacon(TRACKING_TYPES.HOME_PAGE_BOUNCE)
  }
}

export const trackingService = new TrackingService()
